"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
class TestDataSource {
    constructor(featureStore, initialFlags, initialSegments, onStop, listeners) {
        this.featureStore = featureStore;
        this.onStop = onStop;
        this.listeners = listeners;
        // make copies of these objects to decouple them from the originals
        // so updates made to the originals don't affect these internal data.
        this.flags = Object.assign({}, initialFlags);
        this.segments = Object.assign({}, initialSegments);
    }
    async start() {
        this.listeners.forEach(({ processJson }) => {
            const dataJson = { data: { flags: this.flags, segments: this.segments } };
            processJson(dataJson);
        });
    }
    stop() {
        this.onStop(this);
    }
    close() {
        this.stop();
    }
    async upsert(kind, value) {
        return this.featureStore.upsert(kind, value);
    }
}
exports.default = TestDataSource;
//# sourceMappingURL=TestDataSource.js.map